module.exports = __webpack_public_path__ + "static/media/standing.4c24abcb.png";